module.exports = __webpack_public_path__ + "static/media/howItWorksStartupIcon03.76050674.svg";